var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2556_73)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.553 16.1055C17.047 15.8586 17.6477 16.0588 17.8946 16.5528L20.8946 22.5528C21.1416 23.0467 20.9414 23.6474 20.4474 23.8944C19.9535 24.1414 19.3528 23.9412 19.1058 23.4472L16.1058 17.4472C15.8588 16.9532 16.059 16.3525 16.553 16.1055Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44743 16.1055C7.94141 16.3525 8.14164 16.9532 7.89465 17.4472L4.89465 23.4472C4.64766 23.9412 4.04698 24.1414 3.55301 23.8944C3.05903 23.6474 2.8588 23.0467 3.10579 22.5528L6.10579 16.5528C6.35278 16.0588 6.95345 15.8586 7.44743 16.1055Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00586 21C4.00586 20.4477 4.45357 20 5.00586 20H18.9999C19.5521 20 19.9999 20.4477 19.9999 21C19.9999 21.5523 19.5521 22 18.9999 22H5.00586C4.45357 22 4.00586 21.5523 4.00586 21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6C1.55228 6 2 6.44772 2 7V10C2 10.5523 1.55228 11 1 11C0.447715 11 0 10.5523 0 10V7C0 6.44772 0.447715 6 1 6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6C23.5523 6 24 6.44772 24 7V10C24 10.5523 23.5523 11 23 11C22.4477 11 22 10.5523 22 10V7C22 6.44772 22.4477 6 23 6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C5.44728 2 5 2.44728 5 3V16H19V3C19 2.44728 18.5527 2 18 2H6ZM3 3C3 1.34272 4.34272 0 6 0H18C19.6573 0 21 1.34272 21 3V17C21 17.5523 20.5523 18 20 18H4C3.44772 18 3 17.5523 3 17V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C7 4.44772 7.44772 4 8 4H16C16.5523 4 17 4.44772 17 5V9C17 9.55228 16.5523 10 16 10H8C7.44772 10 7 9.55228 7 9V5ZM9 6V8H15V6H9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12C15.4477 12 15 12.4477 15 13C15 13.5523 15.4477 14 16 14Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2556_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.e3264ed21f1227949c2157eca17ef9a8.svg";
export { ForwardRef as ReactComponent };